<template>
  <div>
    <el-image class="image-background" src="https://res.smoktech.com/order/files/1495502995655.png">
      <div slot="placeholder" class="image-slot">
        加载中
        <span class="dot">...</span>
      </div>
    </el-image>
    <div v-loading="loading" class="sign-frame">
      <h1>{{ $t("login.BackgroundManagementSystem") }}</h1>
      <el-form ref="form" :model="form" label-width="70px">
        <el-form-item class="sign-form" :label="$t('login.Account')">
          <el-input v-model.trim="form.username" :placeholder="$t('login.EnterAccount')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('login.Password')">
          <el-input
            v-model.trim="form.password"
            :placeholder="$t('login.EnterPassword')"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item class="login-btn-box">
          <el-button class="login-btn" type="primary" @click="signIn" round>{{ $t("login.Login") }}</el-button>
        </el-form-item>
      </el-form>
      <div class="text_center">
        <el-link
          style="margin-right: 10px"
          @click="registerUser"
          type="primary"
        >{{ $t("login.RegisteredAccount") }}</el-link>
        <el-link
          style="margin-left: 10px"
          @click="forgotPassword"
          type="danger"
        >{{ $t("login.ForgetPassword") }}</el-link>
      </div>

      <h5 class="text_center">
        <span>{{ $t("login.CurrentVersion") }}</span>
        {{ current_version }}
      </h5>
    </div>
    <div class="copyright-text">
      <h5 class="text_center">
        Copyright © {{ new Date().getFullYear() }} Shenzhen IVPS Technology Co.,
        Ltd All Rights Reserved.
      </h5>
    </div>
    <div class="language">
      <el-select
        style="margin-left: 44px"
        v-model="lang"
        placeholder
        @change="changeLangEvent($event)"
      >
        <el-option v-for="item in language_list" :key="item.id" :label="item.type" :value="item.id"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import storage from "../../public/static/js/storage";
export default {
  name: "SignIn",
  data: function() {
    return {
      loading: false,
      form: {
        username: "",
        password: ""
      },
      current_version: process.env.VUE_APP_VERSION,
      language_list: [
        {
          id: "zh",
          type: "中文"
        },
        {
          id: "en",
          type: "English"
        }
      ],
      lang: "zh"
    };
  },
  methods: {
    changeLangEvent(value) {
      this.$confirm(
        this.$t("commonInfo.ChangeLanguage"),
        this.$t("commonInfo.Tips"),
        {
          confirmButtonText: this.$t("commonInfo.Confirm"),
          cancelButtonText: this.$t("commonInfo.Cancel"),
          type: "warning"
        }
      )
        .then(() => {
          this.$i18n.locale = value;
          this.$common.setGlobalStorage("language", value);
          location.reload();
        })
        .catch(err => {
          this.lang =
            storage.get(this.$common.getGlobalStorageKeyName("language")) ||
            "zh";
        });
    },
    signIn: function() {
      if (this.form.username.length > 0) {
        if (this.form.password.length > 0) {
          let _me = this;
          let params = {
            username: _me.form.username,
            password: this.$md5(_me.form.password)
          };
          this.loading = true;
          _me.$common
            .httpPost("/api/user/admin/login", params)
            .then(res => {
              _me.loading = false;
              if (res.code == "1000000") {
                sessionStorage.setItem("_token", res.data.token);
                sessionStorage.setItem("_user", JSON.stringify(res.data));
                _me.navigate();
              } else {
                _me.$message.error(res.message);
              }
            })
            .catch(err => {
              _me.loading = false;
              console.log(err);
              if (err && err.message) {
                _me.$message.error(this.$t("login.LogErr") + err.message);
              }
            });
        } else {
          this.$message.error(this.$t("login.EnterCorrectPwdInfo"));
        }
      } else {
        this.$message.error(this.$t("login.EnterCorrectAccountInfo"));
      }
    },
    forgotPassword() {
      this.$router.push("/forgot-password");
    },
    registerUser() {
      // console.log("注册账号")
      this.$router.push("/user-register");
    },
    navigate: function() {
      sessionStorage.setItem("_login", "true");
      window.location.href = "/";
    }
  },
  created() {},
  mounted() {
    let _me = this;
    // let is_login = sessionStorage.getItem("_login");
    if (this.$common.getGlobalStorage("language") != undefined) {
      _me.$i18n.locale = this.$common.getGlobalStorage("language");
      _me.lang = this.$common.getGlobalStorage("language");
    }
  }
};
</script>

<style scoped>
.image-background {
  width: 580px;
  height: 315px;
  position: fixed;
  top: 50%;
  right: 0;
  margin-top: -220px;
  margin-right: 700px;
}

.sign-frame {
  width: 400px;
  height: 330px;
  position: fixed;
  top: 50%;
  right: 0;
  margin-top: -240px;
  margin-right: 200px;
}

.sign-form {
  margin-top: 50px;
}

.login-btn {
  width: 100%;
  float: right;
}

.copyright-text {
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  margin-bottom: 0px;
}

h1 {
  font-size: 24px !important;
  text-align: center;
}
.language {
  position: absolute;
  top: 50px;
  right: 150px;
}
</style>
